import { device, store as libraryStore } from '@rfc/rfc-components-library/store'
import { Store, createStore } from 'vuex'
import { type TagProducerStoreState } from './storeType'

//import modules used
import type { Router } from 'vue-router'
import i18n from '../locales/i18n'
import customer from './customerStore/customer.module'
import filters from './filtersStore/filters.module'
import notification from './notificationStore/notification.module'
import order from './orderStore/order.module'
import productionLine from './productionLinesStore/productionLine.module'
import product from './productStore/product.module'
import printTemplate from './templateStore/template.module'

const setupStore = (storeRouter: Router): Store<TagProducerStoreState> =>
    createStore({
        modules: {
            ...libraryStore(storeRouter as any, i18n),
            device: {
                ...device,
                actions: { ...device.actions(storeRouter, i18n) }
            },
            customer,
            filters,
            notification,
            order,
            product,
            productionLine,
            printTemplate
        },
        devtools: true
    })

export default setupStore
